import { render, staticRenderFns } from "./Infographic7.vue?vue&type=template&id=4d6f6b3c&scoped=true&"
import script from "./Infographic7.vue?vue&type=script&lang=js&"
export * from "./Infographic7.vue?vue&type=script&lang=js&"
import style0 from "./Infographic7.vue?vue&type=style&index=0&id=4d6f6b3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6f6b3c",
  null
  
)

export default component.exports